import { BadgeVariant } from "./Badge.types";
const MAX_ITEMS = 99;
export const getSize = (variant) => {
    if (variant === BadgeVariant.SM) {
        return 16;
    }
    if (variant === BadgeVariant.LG) {
        return 32;
    }
    return 24;
};
export const displayLabel = ({ variant, label, }) => {
    if (variant === BadgeVariant.SM) {
        return "";
    }
    return label <= MAX_ITEMS ? `${label}` : "99+";
};
//# sourceMappingURL=helpers.js.map